// src/components/Tabs.jsx
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import SetterTab from "./SetterTab";
import FilesTab from "./FilesTab";
import ImagesTab from "./ImagesTab";
import CarouselTab from "./CarouselTab";
import ChatTab from "./ChatTab";
import IDETab from "./IDETab";

const Tabs = ({ selectedTopic }) => {
  return (
    <div className="p-4">
      <Routes>
        <Route path="/" element={<Navigate to="/setter" />} />
        <Route
          path="/setter"
          element={<SetterTab selectedTopic={selectedTopic} />}
        />
        <Route
          path="/files"
          element={<FilesTab selectedTopic={selectedTopic} />}
        />
        <Route
          path="/images"
          element={<ImagesTab selectedTopic={selectedTopic} />}
        />
        {/* <Route path="/genai" element={<GenAITab selectedTopic={selectedTopic} />} /> */}

        <Route
          path="/carousel"
          element={<CarouselTab selectedTopic={selectedTopic} />}
        />
        <Route path="/chat" element={<ChatTab />} />
        <Route path="/ide" element={<IDETab topic={selectedTopic} />} />
        {/* Default Routes */}
        <Route path="*" element={<Navigate to="/setter" />} />
      </Routes>
    </div>
  );
};

export default Tabs;
